import { translate } from '../../../common/intl';
import FBAutocompleteAsyncState from '../FBAutocompleteAsync/FBAutocompleteAsync.state';
import FBAutocompleteAsyncStore from '../FBAutocompleteAsync/FBAutocompleteAsync.store';
import { FBAutocompleteAsyncOption } from '../FBAutocompleteAsync/FBAutocompleteAsync.types';
import { MaterialOption } from '../FBMaterialsTable/MaterialTable/types';

interface RevisionLabelSource {
  document?: { docId?: string }
  displayRevision?: string
  name?: string
}

class FBProcedureCatalogState {
  // MARK: @config
  public materialsApi = new FBAutocompleteAsyncState({ optionId: FBAutocompleteAsyncOption.materials, shouldLoadImmediate: false });
  public equipmentApi = new FBAutocompleteAsyncState({ optionId: FBAutocompleteAsyncOption.equipment, shouldLoadImmediate: false });
  public lotsApi = new FBAutocompleteAsyncState({ optionId: FBAutocompleteAsyncOption.ebLots, shouldLoadImmediate: false });

  // MARK: @helpers
  public formatRevisionLabel = (
    item: RevisionLabelSource | undefined,
    fallback: string,
  ): string => {
    if (!item) {
      return fallback;
    }

    return translate('common.select.revision', {
      docId: item.document?.docId,
      displayRevision: item.displayRevision,
      name: item.name,
    });
  };

  public getMaterialRecord = (id?: string): MaterialOption | undefined => {
    if (!id) {
      return undefined;
    }

    return FBAutocompleteAsyncStore.getValue<MaterialOption>(
      FBAutocompleteAsyncOption.materials,
      id,
    );
  };

  public getMaterialLabel = (id?: string): string => {
    if (!id) {
      return '';
    }

    return this.formatRevisionLabel(this.getMaterialRecord(id), id);
  };

  public getEquipmentRecord = <T extends RevisionLabelSource>(id?: string): T | undefined => {
    if (!id) {
      return undefined;
    }

    return FBAutocompleteAsyncStore.getValue<T>(
      FBAutocompleteAsyncOption.equipment,
      id,
    );
  };

  public getEquipmentRevisionLabel = (id?: string): string => {
    if (!id) {
      return '';
    }

    return this.formatRevisionLabel(
      this.getEquipmentRecord<RevisionLabelSource>(id),
      id,
    );
  };
}

export default FBProcedureCatalogState;
